import React from 'react';
import successIcon from '../../Assets/images/Activation/success.svg';
import ButtonNew from '../Button/Button';
import './AddLineSuccess.scss';

type initialProps = {
    history: any;
    deviceDetails: any;
    setIsImeiData: any;
    setIsAddLineJourney: any;
};

const AddLineSuccess = (props: initialProps) => {
    const { history, deviceDetails, setIsImeiData, setIsAddLineJourney } = props;

    const handlePrimaryCTA = () => {
        setIsImeiData(false);
        if (deviceDetails.esim) {
            history.push('/activate-esim');
        } else {
            // history.push('/post-activation-home');
            setIsAddLineJourney(false);
        }
    };

    const handleSecondaryCTA = () => {
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        const isTestAcc: boolean = customerDetails?.category === "TEST" ? true : false;
        setIsImeiData(false);
        if(isTestAcc) {
            props.history.push({
                pathname: '/activation',
            });
        } else {
            if (deviceDetails.esim) {
                // history.push('/post-activation-home');
                setIsAddLineJourney(false);
            } else {
                history.push('/track-order');
            }
        }
    };

    return (
        <div className="AddLineSuccessContainer">
            <div className="success-tick">
                <img src={successIcon} alt="successIcon" />
            </div>
            <div className="addlineSuccessTitle">Line Added Successfully!</div>
            <div className="addlineSuccessMsg">
                Congratulations! You've successfully added an additional <br />
                line to your account.
            </div>

            <div className="confirm-btn">
                <ButtonNew primary={true} onClick={handlePrimaryCTA}>
                    {deviceDetails.esim ? 'ACTIVATE NOW' : 'CONTINUE'}
                </ButtonNew>
            </div>
            <div className="activate-ltr-btn" onClick={handleSecondaryCTA}>
                {deviceDetails.esim ? 'ACTIVATE LATER' : 'TRACK ORDER'}
            </div>
        </div>
    );
};

export default AddLineSuccess;
